import { createAction } from '@ngrx/store';

export const initializeStore = createAction('[App] Initialize Store');
export const storeInitialized = createAction('[App] Store Initialized');
